module.exports = __webpack_public_path__ + "img/instagram.cc0b788f.svg";